export enum surveySectionId {
    simulationModuleOne = 0,
    identification = 1,
    fatca = 10,
    finance = 11,
    risk = 12,
    knowledgeIntro = 13,
    knowledgeFailed = 14,
    knowledgeQuit = 15,
    knowledgePassed = 16,
    knowledgeFrozen = 17,
    knowledgeSetOne = 18,
    knowledgeSetTwo = 19,
    knowledgeSetThree = 20,
    knowledgeSetFour = 21,
    knowledgeSetFive = 22,
    knowledgeSetSix = 23,
    KnowlwdgeFrozenPeriodNotOver = 24,
    advice = 25,
    onboarding = 26,
    sustainability = 27,
    welcome=2,
    needs=4,
    budget=5,
    formula = 11,
    kid = 12,
    knowledge = 13,
    knowledgeYongoBr21 = 14,
    knowledgeYongoBr23 = 15,
    knowledgeYongoFeedback = 16,
    contract = 26
}

